import { HeroSection } from "@/components/design-system/HeroSection/HeroSection";
import { URLS } from "@/data/constants";
import { trackCalendlyClick } from "@/utils/analytics";
import React from "react";

export const WealthHeroSection: React.FC = () => {
  const handleCalendlyClick = () => {
    trackCalendlyClick("wm_hero");
    window.open(URLS.CALENDLY, "_blank");
  };

  return (
    <HeroSection
      headline="You're missing AUM that's hiding in plain sight."
      description="Get qualified prospects with financial intent through AI-powered participant conversations and turn retirement into wealth."
      primaryCta={{ label: "Book a demo", onClick: handleCalendlyClick }}
      backgroundImage="/wm-hero.jpg"
      imageClassName="absolute top-0 right-0 h-full w-[65%] object-cover"
    />
  );
};
